import * as palette from "@govlaunch/palette";
import ProfilePicture from "@govlaunch/profile-picture";
import React from "react";
import DisruptorD from "~/components/icons/DisruptorD";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import SponsorshipBadges from "~/components/vendor/profile/SponsorshipBadges";

interface IVendorOwnerInfoProps {
  vendor: NonNullable<IVendorQuery["company"]>;
}

export default function VendorOwnerInfo({ vendor }: IVendorOwnerInfoProps) {
  const showSponsorshipsBadges = vendor.sponsorships && vendor.sponsorships.length > 0;

  return (
    <div
      css={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        width: "100%",
        padding: 16,
        overflow: "hidden",
      }}
    >
      <div
        css={{
          position: "relative",
        }}
      >
        <ProfilePicture
          size={48}
          disruptor={vendor.isDisruptor}
          image={vendor.logo}
          name={vendor.name}
          css={{
            borderWidth: !showSponsorshipsBadges && vendor.isDisruptor ? 2 : 1,
          }}
        />

        {showSponsorshipsBadges && <SponsorshipBadges sponsorships={vendor.sponsorships} vendorLogoSize={48} />}

        {!showSponsorshipsBadges && vendor.isDisruptor && (
          <DisruptorD
            width={18}
            height={18}
            style={{
              position: "absolute",
              bottom: -3,
              right: -3,
            }}
          />
        )}
      </div>

      <div
        css={{
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        <h1
          title={vendor.name}
          css={{
            margin: "8px 0 0",
            color: palette.darkGray,
            fontSize: 20,
          }}
        >
          {vendor.name}
        </h1>
      </div>
    </div>
  );
}
